<template>
    <div class="rolejuisdiction">
        <div class="search-bar">
            <el-button @click="newAddRole" type="primary">+新增角色</el-button>
            <div class="search-box">
                <span class="input-lable">角色名称</span>
                <el-input placeholder="请输入内容" v-model="searchValue" style="width:220px;" @keyup.enter.native="goSearch"></el-input>
                <span class="input-lable" style="margin-left:20px;">使用状态</span>
                <el-select v-model="searchStatus" style="width:120px" placeholder="请选择">
                    <el-option label="启用" value='on'></el-option>
                    <el-option label="禁用" value='off'></el-option>
                </el-select>
                <el-button @click="goSearch" type="primary" style="width:90px;padding:10px;margin-left:8px;">查询</el-button>
                <el-button @click="clearSearch" style="width:60px;padding:10px;">重置</el-button>
            </div>
        </div>
        <div class="table-box">
            <template>
                <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    prop="role_label"
                    label="角色名称"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="active_status"
                    label="使用状态"
                    width="180">
                    <template slot-scope="scope">
                        <span class="enable" v-if="scope.row.active_status">启用</span>
                        <span class="prohibit" v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="created_time"
                    label="创建时间"
                    width="180">
                    <template slot-scope="scope">{{scope.row.created_time | formatDate}}</template>
                </el-table-column>
                <el-table-column
                    align="right"
                    prop="active_status"
                    label="操作">
                    <template slot-scope="scope" v-if="scope.row.role_name!=='ROOT'">
                        <el-button @click="editRole(scope.row)" class="btn-span" type="text">编辑</el-button>
                        <el-button @click="distRole(scope.row)" class="btn-box" v-if="scope.row.active_status" type="text">分配权限</el-button>
                        <el-button @click="delRole(scope.row)" class="btn-box" v-else type="text">删除</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </template>
        </div>
        <template>
            <Dialog :dialogData="dialogData" @close-dialogStatus="Close_dialog"></Dialog>
        </template>
    </div>
</template>
<script>
import Edit from './components/edit';
import DistRole from './components/distRole';
import Delete from './components/deleteMessage';
import Dialog from "@/components/Dialog"
import Role from "@/api/RoleModule";
import {formatDate} from '@/assets/js/public'
export default {
    filters: {
        formatDate(time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
        }
    },
    components: { Dialog },
    data(){
        return {
            istrue:false,
            searchValue:'',
            searchStatus:'',
            dialogData:{},
            tableData: [],
            eaitData:{},
            dialogType:''
        }
    },
    methods:{
        goSearch(){
            var datas = `page=${1}${this.searchValue?'&search='+this.searchValue:''}${this.searchStatus?'&status='+this.searchStatus:''}`
            Role.searchRoleList(datas)//
            .then((res) => {
                this.tableData = res.data.data;
            }).catch((err) => {
                console.log(err)
            });
        },
        clearSearch(){//清除
            this.searchValue = '';
            this.searchStatus = '';
            this.getRoleData()
        },
        newAddRole(){
            this.dialogData={
                title:'新增角色',
                dialogVisible:true,
                width:'453px',
                buttonNum:true,
                render: (h,scope) => {
                    var that = this;
                    return this.$createElement(
                        Edit,{
                            ref:'cli',
                            props:{
                               roleData:{},
                               dialogType:'new',
                               isdisabled:false
                            },
                            on: {
                                datamaseg(el,dialogType,istrue){
                                    that.istrue = istrue;
                                    that.dialogType = dialogType;
                                    that.eaitData = el;
                                    that.callback_fun()
                                }
                            }
                        }
                    )  
                }
            }
        },
        editRole(data){
            this.dialogData={
                title:'编辑',
                dialogVisible:true,
                width:'453px',
                buttonNum:true,
                render: (h,scope) => {
                    var that = this;
                    return this.$createElement(
                        Edit,{
                            ref:'cli',
                            props:{
                               roleData:data,
                               dialogType:'edit',
                               isdisabled:data.active_status?true:false
                            },
                            on: {
                                datamaseg(el,dialogType,istrue){
                                    that.istrue = istrue;
                                    that.dialogType = dialogType;
                                    that.eaitData = el;
                                    that.callback_fun()
                                }
                            }
                        }
                    )  
                }
            }
        },
        delRole(data){
            this.dialogData={
                title:'',
                dialogVisible:true,
                width:'453px',
                buttonNum:true,
                render: (h,scope) => {
                    var that = this;
                    return this.$createElement(
                        Delete,{
                            ref:'cli',
                            props:{
                               roleData:data,
                               dialogType:'del',
                               name:'角色'
                            },
                            on: {
                                datamaseg(el,dialogType,istrue){
                                    that.istrue = istrue;
                                    that.dialogType = dialogType;
                                    that.eaitData = el;
                                    that.callback_fun()
                                }
                            }
                        }
                    )  
                }
            }
        },
        distRole(data){
            this.dialogData={
                title:'分配权限',
                dialogVisible:true,
                width:'720px',
                buttonNum:true,
                render: (h,scope) => {
                    var that = this;
                    return this.$createElement(
                        DistRole,{
                            ref:'cli',
                            props:{
                                roleData:data,
                               dialogType:'edit'
                            },
                            on: {
                                datamaseg(el,dialogType,istrue){
                                    that.istrue = istrue;
                                    that.dialogType = dialogType;
                                    that.eaitData = el;
                                    that.callback_fun()
                                }
                            }
                        }
                    )  
                }
            }
        },
        callback_fun(){
            var that = this;
            if(that.istrue==='false'||that.istrue===false) return false;
            var id = this.eaitData.id;
            var datas = {
                role_name:this.eaitData.roleName,
                role_label:this.eaitData.roleName,
                role_detail:this.eaitData.roleDetail,
                active_status:this.eaitData.status
            }
            if(this.dialogType==="new"){
                Role.addRole(datas)//
                .then((res) => {
                    that.dialogData['dialogVisible'] = false;
                }).catch((err) => {
                    if(err.data.status===202||err.data.status===203){
                        that.$refs.cli.accountReg('datas')
                    }
                });
            }else if(this.dialogType==="edit"){
                if(that.eaitData['status']===false){
                    delete datas['active_status']
                }
                let roledata = JSON.stringify(datas.role_detail),
                newdata = JSON.parse(roledata);//深拷贝
                newdata.forEach(element => {
                    let view_code = element.view_power.find(item => {
                        return item.isActive === true;
                    });
                    element.view_code = !!view_code?view_code.code:0;
                    let handle_code = element.handle_power.find(item => {
                        return item.isActive === true;
                    });
                    element.handle_code = !!handle_code?handle_code.code:0;
                });
                datas.role_detail = newdata;
                console.log(newdata)
                Role.modifyRole(id,datas)//
                .then((res) => {
                    that.dialogData['dialogVisible'] = false;
                }).catch((err) => {
                    if(err.status===400&&err.data.status===201){
                        this.$message.error('不可以关闭已经开启的角色');
                    }else {
                        that.$refs.cli.accountReg('datas')
                    }
                });
            }else if(this.dialogType==="del"){
                Role.deleteRole(id)//
                .then((res) => {
                    that.dialogData['dialogVisible'] = false;
                }).catch((err) => {
                    if(err.status===400&&err.data.status===201){
                        this.$message.error('不可以删除已经开启的角色');
                    }
                });
            }
            setTimeout(function(){
                that.getRoleData()
            },500)
        },
        Close_dialog(){
            //处理组件
            this.$refs.cli.Submission('datas')
        },
        getRoleData(){
            Role.getRoleList()//获取角色列表
            .then((res) => {
                this.tableData = res.data.data;
            }).catch((err) => {
                console.log(err)
            });
        }
    },
    watch:{
        
    },
    mounted() {
       this.getRoleData()
    },
   
}
</script>
<style scoped>
    .search-bar{
        position: absolute;
        top: 84px;
        width: 1028px;
        height: 78px;
        background:#FFFFFF;
        border-radius:5px;
        padding: 0 30px 0 22px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        justify-content: space-between;
        -webkit-justify-content: space-between;
    }
    .search-box{
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
    }
    .input-lable{
        width:59px;
        height:19px;
        font-size:14px;
        color:#666666;
        line-height:19px;
    }
    .table-box{
        /* position: absolute; */
        width: 1020px;
        min-height: 600px;
        /* top: 162px; */
        /* bottom: 0; */
        /* overflow: auto; */
        background:#fff;
        border-radius:5px;
        margin-top: 88px;
        padding: 0 30px;
    }
    .enable{
        font-size:12px;
        color:#249E77;
        line-height:16px;
    }
    .prohibit{
        font-size:12px;
        color:#DE5F5F;
        line-height:16px;
    }
    .btn-box{
        width: 52px;
        text-align: right;
        font-size: 12px;
    }
    .btn-span{
        font-size: 12px;
    }
</style>
<style>
    .has-gutter{
        line-height: 34px;
    }
    .el-message-box{
        width: auto;
    }
    .el-message-box__title{
       color: #333333!important;
       font-size: 16px!important;
       height: 16px;
    }
    .el-message-box--center .el-message-box__header{
       padding: 15px 15px 15px;
       border-bottom: 1px solid #F5F6F9;
   }
    .el-button--small, .el-button--small.is-round {
        padding: 9px 30px;
    }
    .el-button--mini, .el-button--small {
        font-size: 14px;
    }
    .el-form-item__label{
        line-height: 34px;
        color: #666666;
    }
    .rolejuisdiction{
        overflow: hidden;
    }
    .rolejuisdiction .el-form-item__content,.el-input__inner{
        height: 34px;
        line-height: 34px;  
    }
    .rolejuisdiction .el-input__icon{
        line-height: 34px;
    }
</style>


// WEBPACK FOOTER //
// src/views/role/roleJurisdiction.vue